import { Injectable, Inject } from '@angular/core';
import {
  GetRecPlanNameSearchQuery,
  RecPlanNameSearchListVM,

  PlanImgObject,
  PlanRoom2VM,
  PlanRoomVM,
  SearchPlanRoom2ListVM,
  GetRecPlanBPSearchQuery
} from '../shared/viewmodels/ISearchServiceReg';

import { formatDate, parseDate } from "devextreme/localization";
import { HttpClient, HttpParams, HttpErrorResponse, HttpHeaders, HttpResponseBase, HttpResponse } from '@angular/common/http';
//import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Observable, throwError, of } from 'rxjs';
//import { mergeMap as _observableMergeMap, catchError as _observableCatch, map } from 'rxjs/operators';
import { mergeMap as _observableMergeMap, catchError, map, switchMap } from 'rxjs/operators';

export class SwaggerException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any; };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}


@Injectable()
export class RecPlanSearchService {
  myAppUrl: string = "";

  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;


  constructor(private _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }


 
  getRecPlanNameSearchResults(search: GetRecPlanNameSearchQuery): Observable<RecPlanNameSearchListVM> {
    let url_ = this.myAppUrl + "api/ES/GetSearchPlanRoom2";

    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);
    console.log(url_);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    return this._http.request("post", url_, options_).pipe(_observableMergeMap((response_: any) => {
      return this.processGetRecPlanNameSearchResponse(response_);
    })).pipe(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetRecPlanNameSearchResponse(<any>response_);
        } catch (e) {
          return <Observable<RecPlanNameSearchListVM>><any>throwError(e);
        }
      } else
        return <Observable<RecPlanNameSearchListVM>><any>throwError(response_);

    }));

  }

  //getRecPlanNameSearchResults(search: GetRecPlanNameSearchQuery): Observable<RecPlanNameSearchListVM> {
  //  let url_ = this.myAppUrl + "api/ES/GetSearchPlanRoom2";

  //  url_ = url_.replace(/[?&]$/, "");
  //  const content_ = JSON.stringify(search);
  //  console.log(url_);

  //  let options_: any = {
  //    body: content_,
  //    observe: "response",
  //    responseType: "blob",
  //    headers: new HttpHeaders({
  //      "Content-Type": "application/json",
  //    })
  //  };
  //  return this._http.request("post", url_, options_).pipe<RecPlanNameSearchListVM>(_observableMergeMap((response_: any) => {
  //    return this.processGetRecPlanNameSearchResponse(response_);
  //  })).pipe<RecPlanNameSearchListVM>(catchError((response_: any) => {
  //    if (response_ instanceof HttpResponseBase) {
  //      try {
  //        return this.processGetRecPlanNameSearchResponse(<any>response_);
  //      } catch (e) {
  //        return <Observable<RecPlanNameSearchListVM>><any>throwError(e);
  //      }
  //    } else
  //      return <Observable<RecPlanNameSearchListVM>><any>throwError(response_);

  //  }));

  //}


  //processGetRecPlanNameSearchResponse(response: HttpResponse<any>): Observable<RecPlanNameSearchListVM> {
  //  if (response.status === 200) {
  //    // Assuming the body directly contains the data we're interested in and is of type RecPlanNameSearchListVM
  //    return of(response.body); // Wraps the body in an Observable
  //  } else {
  //    // Handle non-200 status by returning an observable error
  //    return throwError(() => new Error('An unexpected server error occurred.'));
  //  }
  //}



  processGetRecPlanNameSearchResponse(response: HttpResponseBase): Observable<RecPlanNameSearchListVM> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
    if (status === 200) {
      return this.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = RecPlanNameSearchListVM.fromJS(resultData200);
        return of<RecPlanNameSearchListVM>(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return this.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of<RecPlanNameSearchListVM>(<any>null);

  }

  getRecPlanBPSearchResults(search: GetRecPlanBPSearchQuery): Observable<SearchPlanRoom2ListVM> {
    let url_ = this.myAppUrl + "api/ES/SelectPlanByBookPage";
    url_ = url_.replace(/[?&]$/, "");
    const content_ = JSON.stringify(search);

    let options_: any = {
      body: content_,
      observe: "response",
      responseType: "blob",
      headers: new HttpHeaders({
        "Content-Type": "application/json",
      })
    };
    return this._http.request("post", url_, options_).pipe<SearchPlanRoom2ListVM>(_observableMergeMap((response_: any) => {
      return this.processGetRecPlanBPSearchResponse(response_);
    })).pipe<SearchPlanRoom2ListVM>(catchError((response_: any) => {
      if (response_ instanceof HttpResponseBase) {
        try {
          return this.processGetRecPlanBPSearchResponse(<any>response_);
        } catch (e) {
          return <Observable<SearchPlanRoom2ListVM>><any>throwError(e);
        }
      } else
        return <Observable<SearchPlanRoom2ListVM>><any>throwError(response_);
    
    }));

  }
  processGetRecPlanBPSearchResponse(response: HttpResponseBase): Observable<SearchPlanRoom2ListVM> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse ? response.body :
        (<any>response).error instanceof Blob ? (<any>response).error : undefined;

    let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); } };
    if (status === 200) {
      return this.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = SearchPlanRoom2ListVM.fromJS(resultData200);
        return of(result200);
      }));
    } else if (status !== 200 && status !== 204) {
      return this.blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
        return this.throwException("An unexpected server error occurred.", status, _responseText, _headers);
      }));
    }
    return of<SearchPlanRoom2ListVM>(<any>null);

  }

  blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
      if (!blob) {
        observer.next("");
        observer.complete();
      } else {
        let reader = new FileReader();
        reader.onload = event => {
          observer.next((<any>event.target).result);
          observer.complete();
        };
        reader.readAsText(blob);
      }
    });
  }
  throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
      return throwError(result);
    else
      return throwError(new SwaggerException(message, status, response, headers, null));
  }


  getDocPlanImgByBP(book: string, page: string, booktype: string) {
    console.log('getDocPlanImgByBP');
    //try {
    //  //return this._http.get<PlanImgObject>(this.myAppUrl + 'api/ES/GetDocPlanImgByBP?book=' + book + '&page=' + page + '&booktype=' + booktype);
    //  let res = this._http.get<PlanImgObject>(this.myAppUrl + 'api/ES/GetDocPlanImgByBP?book=' + book + '&page=' + page + '&booktype=' + booktype);
    //  console.log(res);
    //}
    //catch (e) {
    //  console.log(e);
    //}
    return this._http.get<PlanImgObject>(this.myAppUrl + 'api/ES/GetDocPlanImgByBP?book=' + book + '&page=' + page + '&booktype=' + booktype);
  }

  GetDocPlanPage(path: string, page: number) {
    console.log('getDocPlanPage');

    return this._http.get(this.myAppUrl + 'api/ES/GetDocPlanPage?path=' + path + '&page=' + page, { responseType: 'text' });
  }

  GetPlanBP(book: string, page: string, offset: number) {
    return this._http.get<PlanRoom2VM>(this.myAppUrl + 'api/ES/GetPlanBP?book=' + book + '&page=' + page + '&offset=' + offset);
  }

  GetPlanDoc(book: string, page: number) {
    return this._http.get<PlanRoom2VM>(this.myAppUrl + 'api/ES/GetPlanDoc?book=' + book + '&page=' + page);
  }
  
  SelectPlanByPlanID(planid:number) {
    console.log('SelectPlanByPlanID');
    return this._http.get<SearchPlanRoom2ListVM>(this.myAppUrl + 'api/ES/SelectPlanByPlanID?pPlanID=' + planid);
  }

  logError(message: string) {
    this._http.get<string>(this.myAppUrl + 'api/ES/LogError?message=' + message);
  }

  logInfo(message: string) {
    this._http.get(this.myAppUrl + 'api/ES/LogInfo?message=' + message);
  }

  logWarning(message: string) {
    this._http.get<string>(this.myAppUrl + 'api/ES/LogWarning?message=' + message);
  }

  DownloadPlans(imgquery: any) {
    return this._http.get<string>(this.myAppUrl + 'api/ES/LogWarning?message=');
  }

  isInPlanFolder(book: string, page: string): boolean {

    if ((+book < 238) || (+book === 238 && +page < 37/*37*/))
      return true;
    else
      return false;
  }

  setExportCost(filteredCount: number) {
    let totalCost = filteredCount * .02;
    totalCost = +totalCost.toFixed(2);
    if (totalCost < 2)
      totalCost = 2;
    return totalCost
  }

}
